<div class="d-flex ai-center relative">
  <mat-form-field class="input-wrapper-default date-range-wrapper {{rangeClass}}"
                  appearance="outline"
                  [hideRequiredMarker]="true"
                  floatLabel="always">

    <mat-label [hidden]="!showLabel">
      <span>{{label ? label :'common.label.filter-dates' | translate}}</span>
      <span *ngIf="isRequired" class="color-error">*</span>:</mat-label>
    <input
      matInput
      ngxDaterangepickerMd
      [formControl]="ctrl.control"
      placeholder="MM/DD/YYYY - MM/DD/YYYY"
      opens="right"
      [lockStartDate]="false"
      [ranges]="ranges"
      [autoApply]="true"
      [closeOnAutoApply]="true"
      [showCustomRangeLabel]="showRanges"
      [alwaysShowCalendars]="true"
      [customRangeDirection]="true"
      [keepCalendarOpeningWithRange]="true"
      [locale]="locale"
      (change)="onChangeApply($event)"
      (ngModelChange)="onChange($event)"
      class="relative"
      data-lpignore="true"
      [attr.data-test-id]="testId ? ([testId, 'input'] | join) : 'input_date_range'"
    />
    <span aria-hidden="true"
          (click)="openCalendar()"
          class="icon icon-calendar color-gray-darker" matSuffix></span>
  </mat-form-field>

  <button *ngIf="buttonLocation === 'inside' && selected && selected.startDate" mat-icon-button
          type="button" [disabled]="isDisabled"
          class="inline-clear-button"
          [attr.data-test-id]="testId ? ([testId, 'button_clear'] | join) : 'button_clear_date_range'"
          (click)="clear()">
    <span class="icon icon-close fs-md"></span>
  </button>
  <button *ngIf="buttonLocation === 'outside' && selected && selected.startDate"
          type="button" [disabled]="isDisabled"
          class="reset-button link-secondary row ai-center mt-1 clear-button"
          [attr.data-test-id]="testId ? ([testId, 'button_clear'] | join) : 'button_clear_date_range'"
          (click)="clear()">
    <span class="icon icon-close"></span>
    <span>{{(buttonClearLabel || 'common.button.clear') | translate}}</span>
  </button>
</div>
